/* @generated */
import * as React from "react";
import { contentIconRecipe } from "../styles/index.css.esm.js";
import classNames from "classnames";
import { useThemedStyle } from "../hooks/useThemedStyle.esm.js";
import { BackgroundFileSmall } from "./_background/background-file-small.esm.js";
import { useCompositeContentIconViewBox } from "../hooks/useContentIconViewbox.esm.js";
const FileAutodeskSmall = ({
  className,
  hasWhitespace = true,
  over = "base",
  hasBackground = true,
  ...props
}) => {
  const cls = classNames([
    "dig-ContentIcon",
    className,
    "dig-ContentIcon--small",
    {
      "dig-ContentIcon--overBase": over === "base",
      "dig-ContentIcon--overSubtle": over === "subtle",
      "dig-ContentIcon--hasNoBackground": !hasBackground
    },
    contentIconRecipe({ over, hasNoBackground: !hasBackground })
  ]);
  const style = useThemedStyle({ over });
  const viewBox = useCompositeContentIconViewBox({ hasWhitespace, size: "small" });
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      viewBox,
      fill: "none",
      role: "presentation",
      focusable: "false",
      width: 40,
      height: 40,
      className: cls,
      "data-testid": "FileAutodeskSmall",
      style,
      ...props
    },
    hasBackground ? /* @__PURE__ */ React.createElement(BackgroundFileSmall, null) : null,
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m10.344 18.846 2.457-1.833a.5.5 0 0 0-.299-.901h-1.145a.253.253 0 0 1-.239-.34l1.175-3.232a.253.253 0 0 1 .477 0l2.284 6.28a.507.507 0 0 0 .476.334h1.963a.506.506 0 0 0 .476-.68l-3.687-10.14A.507.507 0 0 0 13.806 8h-2.549a.507.507 0 0 0-.476.333l-2.75 7.543a.507.507 0 0 0 .05.447l1.532 2.39a.506.506 0 0 0 .73.133Z",
        fill: "#3BA0F3"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m10.343 18.848 2.46-1.822a.507.507 0 0 0-.302-.914H8.13a.101.101 0 0 0-.086.156l1.57 2.447a.505.505 0 0 0 .728.133Z",
        fill: "#00D6B6"
      }
    )
  );
};
export {
  FileAutodeskSmall
};
